import React, { useEffect } from "react";
import { FormControl, Select, Menu, MenuItem, Typography } from "@mui/material";
import { generateClient } from "aws-amplify/api";
import { listCategories } from "../../graphql/queries";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/slices/apiSlice";
import { useState } from "react";
import { setCategories } from "../../redux/slices/contentSlice/contentForm/contentForm";

const Language = ({ formik }) => {
  return (
    <>
      <FormControl fullWidth>
        <label style={{ margin: "10px 0" }} htmlFor="content-type">
          Language
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
        <Select
          name="language"
          id="language"
          value={formik.values.language}
          onChange={formik.handleChange}
        >
          <MenuItem disabled value=" ">
            <em>Select Language</em>
          </MenuItem>
          <MenuItem value={"eng"}>English</MenuItem>
          <MenuItem value={"spa"}>Spanish</MenuItem>
          <MenuItem value={"fra"}>French</MenuItem>
          <MenuItem value={"deu"}>German</MenuItem>
          <MenuItem value={"zho"}>Chinese</MenuItem>
          <MenuItem value={"jpn"}>Japanese</MenuItem>
          <MenuItem value={"kor"}>Korean</MenuItem>
          <MenuItem value={"urd"}>Urdu</MenuItem>
          <MenuItem value={"ara"}>Arabic</MenuItem>
        </Select>
      </FormControl>
      {formik.touched.language && formik.errors.language && (
        <Typography sx={{ color: "red" }}>{formik.errors.language}</Typography>
      )}
    </>
  );
};

export default Language;
